var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._v(" 无访问权限，请尝试退出应用后重新登录 ")])}
var staticRenderFns = []

export { render, staticRenderFns }